import type { UnitInfoHybridCrusherInterface } from 'store/units/types';
import type { UnitConfigParams } from 'unitData/BaseUnitConfig';
import { BaseUnitConfig } from 'unitData/BaseUnitConfig';
import type { HybridCrusherCRUnitInfoDataInterface } from './unitInfoData';

export class HybridCrusherCRConfig extends BaseUnitConfig {
  static getDefaultData(
    params?: UnitConfigParams,
  ): UnitInfoHybridCrusherInterface {
    const unitInfoData = (params?.data ??
      {}) as HybridCrusherCRUnitInfoDataInterface;

    if (!unitInfoData.configurations) {
      throw new Error('expected configurations to be set');
    }

    return {
      modelName:
        unitInfoData.configurations.rollDiameters[
          parseInt(unitInfoData.configurations?.defaultRollDiameter)
        ].rollWidths[parseInt(unitInfoData.configurations?.defaultRollWidth)]
          .displayName,
      rollDiameter: parseInt(unitInfoData.configurations?.defaultRollDiameter),
      rollWidth: parseInt(unitInfoData.configurations?.defaultRollWidth),
      segment: unitInfoData.configurations.defaultSegment,
      gapSetting: unitInfoData.configurations.defaultAdaptedGapSetting,
      compressiveStrength: 100,
      ...BaseUnitConfig.getBaseDefaults(),
      display: {
        ...BaseUnitConfig.getDefaultDisplay(),
        displayLoad: true,
        displayRiskLevel: false,
        displayCompStrength: true,
        displayRollDiameter: false,
        displayRollWidth: false,
        displaySegment: false,
        displayGapSetting: false,
      },
    };
  }

  static getNumberOfPorts(): number {
    return 2;
  }
}

export const hybridCrusherCRConfig = new HybridCrusherCRConfig();
